import React, { useEffect } from 'react';

import banner1 from "../images/Banner1.png";
import banner2 from "../images/Banner2.png";
import banner3 from "../images/Banner3.png";

function WhatWeDo() {
  useEffect(() => {
    const initAOS = async () => {
      try {
        const AOS = (await import('https://cdn.jsdelivr.net/npm/aos@2.3.4/dist/aos.js')).default;
        if (AOS && typeof AOS.init === 'function') {
          AOS.init({ 
            duration: 800,
            once: true,
            easing: 'ease-out-cubic'
          });
        }
      } catch (error) {
        console.log('AOS loading skipped');
      }
    };
    initAOS();
    
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/aos@2.3.4/dist/aos.css';
    document.head.appendChild(link);
  }, []);

  return (
    <div
      id="program"
      className="relative z-20 max-w-6xl mx-auto flex flex-col items-center justify-center w-full px-4 pt-32 pb-16 bg-white"
    >
      {/* Heading */}
      <h1
        className="text-2xl sm:text-3xl md:text-3xl font-light text-gray-900 text-center"
        data-aos="fade-up"
      >
        Banner{" "}
        <span className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#6D0C22] to-[#0E386B]">
          Program
        </span>
      </h1>

      {/* Subheading */}
      <p
        className="text-sm font-normal sm:text-base md:text-base text-black text-center mt-2 px-2"
        data-aos="fade-up"
        data-aos-delay="100"
      >
        Supply Chain Engineering and Logistics Technologies
      </p>

      {/* Cards Section */}
      <div className="mt-10 w-full max-w-5xl grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Card 1 */}
        <div className="bg-gray-100 rounded-xl p-6 flex flex-col items-center text-center transform transition duration-300 hover:scale-[1.01]" data-aos="fade-up" data-aos-delay="200">
          <img
            src={banner1}
            alt="Workplace Safety"
            className="w-32 sm:w-36 md:w-40 h-auto mb-4"
          />
          <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-1">
            Workplace Safety and Customer Experience
          </h3>
          <p className="text-sm text-gray-600 pt-4">
            Supports startups with tools for process optimization, automation, and data analytics—plus expert mentorship and pilot project support.
          </p>
        </div>

        {/* Card 2 */}
        <div className="bg-gray-100 rounded-xl  p-6 flex flex-col items-center text-center transform transition duration-300 hover:scale-[1.01]" data-aos="fade-up" data-aos-delay="300">
          <img
            src={banner2}
            alt="Operational Efficiency"
            className="w-32 sm:w-36 md:w-40 h-auto mb-4"
          />
          <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-1">
            Services for Operational Efficiency Startups
          </h3>
          <p className="text-sm text-gray-600 pt-4">
            We offer safety tech, customer service tools, and compliance training for startups in workplace safety and customer experience.
          </p>
        </div>

        {/* Card 3 */}
        <div className="bg-gray-100 shadow-md p-6 flex flex-col items-center text-center transform transition duration-300 hover:scale-[1.01]" data-aos="fade-up" data-aos-delay="400">
          <img
            src={banner3}
            alt="Sustainable Logistics"
            className="w-32 sm:w-36 md:w-40 h-auto mb-4"
          />
          <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-1">
            Sustainable Warehousing and Logistics Distribution
          </h3>
          <p className="text-sm text-gray-600 pt-4">
            For sustainable logistics, we provide eco-tech, green strategies, and access to partners and investors focused on sustainability.
          </p>
        </div>
      </div>
    </div>
  );
}

export default WhatWeDo;